import { __assign } from "tslib";
export var getRuntimeCustomFields = function (customFields, formValues, customFieldsConf) {
    if (!customFieldsConf) {
        return customFields;
    }
    return customFieldsConf.reduce(function (fields, conf) {
        var field = customFields.find(function (fieldValue) { return fieldValue.name === conf.id; });
        if (!field) {
            return fields;
        }
        fields.push(__assign(__assign({}, field), { mandatory: !!conf.required, validator: conf === null || conf === void 0 ? void 0 : conf.validator }));
        var dependentFieldsToDisplay = conf.dependentFields &&
            typeof formValues[conf.id] !== 'undefined' &&
            // tslint:disable-next-line: no-non-null-assertion
            conf.dependentFields[formValues[conf.id].toString()];
        if (dependentFieldsToDisplay) {
            fields.push.apply(fields, getRuntimeCustomFields(customFields, formValues, dependentFieldsToDisplay));
        }
        return fields;
    }, []);
};
//# sourceMappingURL=get-runtime-custom-fields.js.map